import { useStaticQuery, graphql } from 'gatsby';

export const useSiteMetadata = () => {
  const {
    site: {
      siteMetadata: {
        siteImage,
        siteUrl,
        siteTitle,
        mainTitle,
        siteDescription,
        author,
        iosAppMeta,
      },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
          mainTitle
          siteTitle: title
          siteImage: image
          siteDescription: description
          author
          iosAppMeta
        }
      }
    }
  `);

  return { siteImage, siteUrl, siteTitle, mainTitle, siteDescription, author, iosAppMeta } || {};
};
